import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vaku_access_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
  return cfg;
});

/**
 * Stream SSE from backend AI endpoints.
 */
export async function streamSSE(path, body, { onDelta, onDone, onError } = {}) {
  try {
    const headers = { "Content-Type": "application/json" };
    const t = tokenStore.get();
    if (t) headers.Authorization = `Bearer ${t}`;
    const resp = await fetch(`${API}${path}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    if (!resp.ok || !resp.body) {
      onError && onError(new Error(`HTTP ${resp.status}`));
      return;
    }
    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let full = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const events = buffer.split("\n\n");
      buffer = events.pop() || "";
      for (const ev of events) {
        const line = ev.trim();
        if (!line.startsWith("data:")) continue;
        const json = line.slice(5).trim();
        if (!json) continue;
        try {
          const obj = JSON.parse(json);
          if (obj.delta) {
            full += obj.delta;
            onDelta && onDelta(obj.delta, full);
          } else if (obj.done) {
            onDone && onDone(full);
          }
        } catch (_e) {
          /* ignore non-JSON event */
        }
      }
    }
    onDone && onDone(full);
  } catch (err) {
    onError && onError(err);
  }
}
